'use strict';
import {stateGo} from 'redux-ui-router';
import {LANDING_VIEW} from '../config/constants';
import {getIsAuthenticated} from '../auth/reducers';
import {getLoginView} from '../auth/router';
import appNavigationAssetProjectsListTemplate from './navigation/ngTemplates/app-navigation-asset-projects-list.html';
import appNavigationAssetsListTemplate from './navigation/ngTemplates/app-navigation-assets-list.html';
import appNavigationOrgsListTemplate from './navigation/ngTemplates/app-navigation-orgs-list.html';
import appNavigationProjectsListTemplate from './navigation/ngTemplates/app-navigation-projects-list.html';
import appRootTemplate from './main-menu.html';


export const APP_ROOT_STATE = 'app';

export const appStates = {
  appRoot: APP_ROOT_STATE,
};

export const navStates = {
  assetProjectsList: 'app.navigation-asset-projects-list',
  assetsList: 'app.navigation-assets-list',
  orgsList: 'app.navigation-orgs-list',
  projectsList: 'app.navigation-projects-list',
};

routerConfig.$inject = [
  '$stateProvider',
  '$urlRouterProvider',
];

export function routerConfig(
  $stateProvider,
  $urlRouterProvider,
) {
  $stateProvider
    .state(appStates.appRoot, {
      url: "/app",
      abstract: true,
      template: appRootTemplate,
      controller: 'MainMenuController',
      resolve: {
        currentUser: [
          'AuthService',
          'AppBootstrapper',
          (AuthService, AppBootstrapper) =>
            AuthService.initAuthComplete()
              .then(() => AppBootstrapper.loaded())
              .then(() => AuthService.getCurrentUser()),
        ],
      },
    })

    .state(navStates.assetProjectsList, {
      title: 'navigation.header.title',
      url: '/projects/assets',
      views: {
        'appContent': {
          template: appNavigationAssetProjectsListTemplate,
        },
      },
    })

    .state(navStates.assetsList, {
      title: 'navigation.header.title',
      url: '/assets',
      views: {
        'appContent': {
          template: appNavigationAssetsListTemplate,
        },
      },
    })

    .state(navStates.orgsList, {
      title: 'navigation.header.title',
      url: '/organizations',
      views: {
        'appContent': {
          template: appNavigationOrgsListTemplate,
        },
      },
    })

    .state(navStates.projectsList, {
      title: 'navigation.header.title',
      url: '/projects',
      views: {
        'appContent': {
          template: appNavigationProjectsListTemplate,
        },
      },
    });


  /*****************************************************************************************************************
   * TBD
   ****************************************************************************************************************/

  // .state('app.schedule', {
  //  url: '/scheduling',
  //  views: {
  //    'appContent': {
  //      templateUrl: "scheduling/schedule.html",
  //      controller: "ScheduleController"
  //    }
  //  }
  // });

  // TODO(redux): Dispatch as action for the otherwise-case, let redux-observable handle this
  // if none of the above states are matched, use this as the fallback
  // Resume use of AuthService after it is imported
  $urlRouterProvider.otherwise(($injector, $location) => {
    const $ngRedux = $injector.get('$ngRedux');
    const $exceptionHandler = $injector.get('$exceptionHandler');

    console.warn('bad path "' + $location.url() + '", rerouting');

    try {
      if (getIsAuthenticated($ngRedux.getState())) {
        $ngRedux.dispatch(stateGo(LANDING_VIEW));
      } else {
        // console.log('$urlRouterProvider.otherwise: not logged in');
        $ngRedux.dispatch(stateGo(getLoginView()));
      }
    } catch (e) {
      $exceptionHandler(e, 'Router.otherwise: Failed to handle router exception');
    }
  });
}



// WEBPACK FOOTER //
// ./src/js/app/router.js